export default "__VITE_ASSET__B$1tY9N6__"